export const inchesToFeetAndInches = (distance?: number | string | null) => {
  if (!distance) {
    return null;
  }

  const feet = Math.floor(Number(distance) / 12);
  const inches = Number(distance) % 12;

  return { feet, inches };
};
